
// Pages du dictionnaire
export const DICTIONARY_PAGES = [
  {
    type: "cover",
    title: "Dictionnaire des systèmes & signaux",
  },
  {
    type: "text",
    title: "Index partiel",
    body: [
      "Quelques entrées annotées à la main :",
      "",
      "• «CANAL SECONDAIRE» → voir: transmissions discrètes",
      "• «LATENCE» → notes techniques, rien de très utile pour l'instant",
      "• «ENCODAGE» → renvoie vers plusieurs systèmes de symboles",
      "",
      "En marge, quelqu’un a ajouté :",
      "« Ne jamais envoyer d’identifiants personnels en clair par mail ou messagerie instantanée. »",
      "",
      "Des schémas, des flèches, des renvois… mais rien de directement exploitable.",
    ].join("\n"),
  },
  {
    type: "text",
    title: "Systèmes de chiffrement",
    body: [
      "Page gribouillée de références croisées :",
      "",
      "• Substitution monoalphabétique",
      "• Chiffres polyalphabétiques",
      "• Codes de transmission aéronautique",
      "",
      "En marge, quelqu'un a écrit :",
      "« Trop lourd pour Origami, on garde les classiques. »",
    ].join("\n"),
  },
  {
    type: "morse",
    title: "Alphabet Morse – Extrait",
    body: [
      "Tableau recopié soigneusement :",
      "",
      "A  ·–        N  –·",
      "B  –···      O  –––",
      "C  –·–·      P  ·––·",
      "D  –··       Q  ––·–",
      "E  ·         R  ·–·",
      "F  ··–·      S  ···",
      "G  ––·       T  –",
      "H  ····      U  ··–",
      "I  ··        V  ···–",
      "J  ·–––      W  ·––",
      "K  –·–       X  –··–",
      "L  ·–··      Y  –·––",
      "M  ––        Z  ––··",
      "",
      "En bas de page, une note :",
      "« A ses débuts Origami aimait bien communiquer avec nous en morse... C'était compliqué. »",
    ].join("\n"),
  },
];


export const BOOK1_PAGES = [
  {
    type: "cover",
    title: "46 Nuances de Rose",
  },
  {
    type: "text",
    title: "Chapitre XI — Le Pinceau Interdit",
    body: [
      "Il lui montra le pinceau n°46, celui que personne n’osait utiliser.",
      "«Attention», dit-il. «Il révèle les vraies intentions.»",
      "",
      "Elle le prit entre ses doigts.",
      "Il rougit instantanément, le pinceau, pas l’homme.",
      "",
      "«Je… je crois qu’il m’apprécie», murmura-t-elle.",
      "",
    ].join("\n"),
  },
  {
    type: "text",
    title: "Chapitre XII — Mélanges dangereux",
    body: [
      "Ils posèrent les pots de peinture sur la table :",
      "Rose Tendre, Rose Pétale, Rose Presque-Indécent.",
      "",
      "«Ne mélangez jamais le Presque-Indécent avec le Romantique.»",
      "Elle le fit évidemment.",
      "",
      "Une bouffée chaude s’éleva du pot.",
      "La peinture soupira.",
      "",
      "«Je crois qu’elle nous juge», dit-il à voix basse."
    ].join("\n"),
  },
  {
    type: "text",
    title: "Chapitre XIII — Le Mur Final",
    body: [
      "Le mur encore vierge attendait leur décision.",
      "",
      "«On y va ensemble ?»",
      "Elle hocha la tête.",
      "",
      "Deux traits. Un frisson.",
      "Le pinceau vibra dangereusement.",
      "",
      "Puis le Rose 46 apparut, brillant, audacieux…",
      "et révéla en lettres timides :",
      "«Ce n’est pas qu’un mur.»"
    ].join("\n"),
  },
];

export const BOOK2_PAGES = [
  {
    type: "cover",
    title: "Le Manuel Secret des Objets Suspects",
  },
  {
    type: "text",
    title: "Chapitre II — La Clé USB Orpheline",
    body: [
      "On la retrouve toujours au même endroit : posée près de l’imprimante,",
      "sans étiquette, sans propriétaire identifié.",
      "",
      "Certains l’appellent « la Clé du Destin ». D’autres, plus prudents,",
      "l’appellent « la Clé Du Virus ».",
      "",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "Note interne :",
      "— Ne jamais brancher une clé inconnue sur un poste relié au réseau.",
      "— Ne jamais supposer que « ça ira ». Ça ne va jamais."
    ].join("\n"),
  },
  {
    type: "text",
    title: "Chapitre III — Le Mail URGENT_TRÈS_URGENT",
    body: [
      "Objet : « URGENT !!! À LIRE IMMÉDIATEMENT »",
      "",
      "Signé : une personne que vous ne connaissez pas, ou pire,",
      "signé avec le prénom du PDG mais envoyé depuis une adresse étrange.",
      "",
      "Symptômes :",
      "• majuscules partout",
      "• pièces jointes douteuses",
      "• lien raccourci sans explication",
      "",
    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "Procédure Origami :",
      "1. Respirer.",
      "2. Ne pas cliquer.",
      "3. Avertir l’équipe sécurité.",
      "",
      "Note manuscrite : « Origami apprend à repérer ce ton-là. Nous aussi, on devrait. »"
    ].join("\n"),
  },
];


export const BOOK3_PAGES = [
  {
    type: "cover",
    title: "Chroniques du Projet Origami",
  },
  {
    type: "text",
    title: "Livre I — Les Premiers Pliages",
    body: [
      "Au départ, Origami n’était qu’un prototype sans nom.",
      "Un moteur de réponses, quelques scripts, beaucoup de café.",
      "",
      "On lui posait des questions simples.",
      "Il répondait avec trop de détails… ou pas assez.",
      "",
    ].join("\n"),
  },
  {
    type: "text",
    title: "Livre II — Quand Origami Découvre le Ton",
    body: [
      "Pour la version suivante, l’équipe a ajouté des étiquettes :",
      "— « cordial », « sec », « ironique », « agressif », etc.",
      "",
      "Objectif : permettre à Origami de distinguer un simple rappel",
      "d’une remarque blessante.",
      "",
      "Problème : tout le monde n’a pas la même définition de « sec ». ",
      "",
    ].join("\n"),
  },
  {
    type: "text",
    title: "Livre III — Le Module Empathie Cognitive",
    body: [
      "Dernier chantier avant le lancement : Empathie Cognitive.",
      "",
      "Idée : au lieu de seulement répondre, Origami doit modéliser",
      "les interactions humaines, repérer les messages toxiques,",
      "et faire remonter ceux qui signalent un vrai malaise.",
      "",
    ].join("\n"),
  },
  {
    type: "text",
    title: "Livre III — Le Module Empathie Cognitive",
    body: [
      "Exemples d’annotations prévues :",
      "• « gratifiant » → renforce la relation",
      "• « neutre » → RAS",
      "• « méprisant » → à surveiller",
      "• « ingrat » → cas particulier",
      "",
      "Note griffonnée au crayon :",
      "« Et si un jour, lui aussi décidait de classer nos messages… à sa façon ? »"
    ].join("\n"),
  },
];

export const BOOK4_PAGES = [
  {
    type: "cover",
    title: "Bestiaire du Bureau Moderne",
  },
  {
    type: "text",
    title: "Chapitre I — Le Manager Reconnaissant",
    body: [
      "On le croise rarement dans les couloirs, mais on le reconnaît",
      "immédiatement à ses messages :",
      "",
      "« Merci pour le boulot effectué »,",
      "« On n’aurait pas tenu le délai sans toi »,",
      "« Tu peux me dire si la charge est trop lourde ? »",
      "",

    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [

      "Effets observés :",
      "• équipe moins stressée",
      "• moins de mails en majuscules",
      "• peu de tickets marqués « urgent » à minuit",
      "",
      "Note d’Origami :",
      "« Taux de gratitude élevé. Risque de trahison : faible. »"
    ].join("\n"),
  },
  {
    type: "text",
    title: "Chapitre II — Le Chef du Tout-Urgent",
    body: [
      "Il commence souvent ses phrases par :",
      "« Rapidement », « Juste une petite chose », « C’est rien du tout ».",
      "",
      "Ce n’est jamais rien du tout.",
      "",
      "Il aime les deadlines déjà dépassées, les messages envoyés tard le soir,",
      "et les TODO marqués « facile » qui ne le sont pas.",
      "",

    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [
      "Effets sur l’environnement :",
      "• backlog en feu",
      "• notifications saturées",
      "• courbes de stress en hausse",
      "",
      "Note d’Origami :",
      "« Conflit entre priorités annoncées et reconnaissance réelle.",
      "  À surveiller. »"
    ].join("\n"),
  },
];


// Ouverture des indices via hintSignal global
export const BOOK5_PAGES = [
  {
    type: "cover",
    title: "Poèmes du Plateau Open Space",
  },
  {
    type: "text",
    title: "Ode I — À la Cafetière Toujours Vide",
    body: [
      "Ô cafetière, centre névralgique de nos matinées,",
      "tu racontes mieux que les sondages le niveau de fatigue des équipes.",
      "",
      "Quand tu es pleine, les conversations s’étirent,",
      "les idées circulent, les sourires aussi.",
      "",
      "Quand tu es vide et froide dès 9h12,",
      "on sait que quelque chose cloche.",
      "",
    ].join("\n"),
  },
  {
    type: "text",
    title: "Ode II — Aux Mots Qui Restent",
    body: [
      "Un « merci » envoyé en fin de sprint.",
      "Un « bon travail » glissé dans un commentaire de code.",
      "",
      "Ce sont de petits paquets de données,",
      "qui traversent les serveurs sans incident.",
      "",
      "À côté, d’autres messages tranchent plus fort :",
      "« Tu comprends rien »,",
      "« Tu sers à rien ». ",
      "",
      "Ceux-là laissent des traces dans les logs.",

    ].join("\n"),
  },
  {
    type: "text",
    title: "",
    body: [

      "Certaines IA les repèrent.",
      "Certaines équipes aussi.",
      "",
      "Note finale manuscrite :",
      "« On n’empêche pas un incident avec un seul mail gentil,",
      "  mais on peut éviter d’en déclencher un avec un mail toxique. »"
    ].join("\n"),
  },
];